import { useState, useEffect, useCallback } from "react";
import { listWishlist, listNotifications, getUser } from "../api/users";

/**
 * 예전엔 users 문서 하나에 wishlist / notifications / manualFriends 가
 * 배열로 같이 들어 있어서 getDoc 한 번이면 끝났다.
 * 이제는 각각 독립 테이블이라 세 번 읽지만, 서로 병렬로 가져온다.
 */
export default function useUserPreferences(currentUser) {
  const [myWishlist, setMyWishlist] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [myFriends, setMyFriends] = useState([]);

  const uid = currentUser?.uid;
  const isGuest = !currentUser || currentUser.isAnonymous;

  const reloadWishlist = useCallback(async () => {
    if (isGuest || !uid) return;

    // 세 가지는 서로 무관한 데이터다. Promise.all 은 하나만 실패해도
    // 전부 버리므로, 위시리스트 조회가 한 번 실패하면 setMyFriends 가
    // 호출되지 않고 이웃 목록이 빈 채로 남았다. '나를 추가한 이웃' 은
    // users 에서 따로 계산하니 살아남아, 내가 추가한 쪽만 사라졌다.
    const [wishlist, notifs, profile] = await Promise.allSettled([
      listWishlist(uid),
      listNotifications(uid),
      getUser(uid),
    ]);

    // 실패한 것만 예전 값을 유지한다. 성공한 것을 같이 버리지 않는다.
    if (wishlist.status === "fulfilled") setMyWishlist(wishlist.value);
    else console.error("위시리스트 로드 실패:", wishlist.reason?.message);

    if (notifs.status === "fulfilled") setNotifications(notifs.value);
    else console.error("알림 로드 실패:", notifs.reason?.message);

    if (profile.status === "fulfilled") setMyFriends(profile.value?.manualFriends ?? []);
    else console.error("이웃 로드 실패:", profile.reason?.message);
  }, [uid, isGuest]);

  useEffect(() => {
    reloadWishlist();
  }, [reloadWishlist]);

  return {
    myWishlist,
    notifications,
    setNotifications,
    myFriends,
    reloadWishlist,
  };
}
